import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const api = axios.create({ baseURL: API_BASE_URL });
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export type TransitQuality = 'harmonious' | 'challenging' | 'neutral';

export interface TransitInfluence {
  id: string;
  transiting_planet: string;
  transiting_sign: string;
  transiting_degree: number;
  transiting_house: number | null;
  aspect: string;
  natal_point: string;
  natal_sign: string;
  natal_degree: number;
  quality: TransitQuality;
  start_date: string;
  end_date: string;
  days_until: number;
  headline: string;
  text: string;
}

export interface TransitsResponse {
  has_birth_chart: boolean;
  date?: string;
  active: TransitInfluence[];
  upcoming: TransitInfluence[];
  upcoming_window_days: number;
}

export interface RetrogradeInfo {
  planet: string;
  sign: string;
  degree: number;
  house: number | null;
  start_date: string;
  end_date: string;
  headline: string;
  text: string;
  house_note: string | null;
}

export interface RetrogradesResponse {
  available: boolean;
  date: string;
  retrogrades: RetrogradeInfo[];
}

export const transitService = {
  async getMyTransits(): Promise<TransitsResponse> {
    const r = await api.get('/astral/transits');
    return r.data;
  },
  async getMyRetrogrades(): Promise<RetrogradesResponse> {
    const r = await api.get('/astral/retrogrades');
    return r.data;
  },
};

export default transitService;
